import BaseModelAPI from '../BaseModelAPI';

export default class Customer extends BaseModelAPI {
	static entity = 'customer';
	static entityName = 'customer';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.officeAddress = '';
			this.officePhoneNumber = '';
			this.stockLevel = 0;
			this.destination = '';
			this.contactPerson = '';
			this.contactPersonPhoneNumber = '';
			this.contactPersonEmail = '';
			this.codeSuratJalan = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}